import type DistinguishedFolderIdName from "owa-service/lib/contract/DistinguishedFolderIdName";
import { UNIFIED_INBOX_FOLDER_NAME_PREFIX, UnifiedInboxSupportedFolders } from "owa-folders-constants";

// Extracts the distinguished folder ID from a unified inbox folder ID
export function getUnifiedInboxDistinguishedFolderId(unifiedInboxFolderId: string | undefined | null): DistinguishedFolderIdName {
    if (unifiedInboxFolderId &&
        unifiedInboxFolderId.indexOf(UNIFIED_INBOX_FOLDER_NAME_PREFIX) === 0) {
        const folderName = unifiedInboxFolderId.substring(UNIFIED_INBOX_FOLDER_NAME_PREFIX.length) as DistinguishedFolderIdName;
        if (UnifiedInboxSupportedFolders.includes(folderName)) {
            return folderName;
        }
    }
    
    return "none";
}
